import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, useTheme } from "@mui/material";
import { RootState } from "../../store/Index";
import { getMyCrewMemberId } from "./components/useCrewTask";
import DashboardWidgetRenderer from "../configurations/dashboard-widgets/DashboardWidgetRenderer";
import NavBar from "../mms-landingpage/components/NavBar";
import { tokens } from "../../theme";

const Sales = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [crewMemberId, setCrewMemberId] = useState<number | null>(null);

  const userId = useSelector((state: RootState) => state.auth.user?.id);

  useEffect(() => {
    if (userId) {
      getMyCrewMemberId(userId).then((id) => setCrewMemberId(id));
    }
  }, [userId]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: colors.primary[800],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar showSearch />
      <Box sx={{ flexGrow: 1 }}>
        <DashboardWidgetRenderer
          dashboardKey="sales"
          widgetProps={{
            selectedDate,
            onDateSelect: setSelectedDate,
            crewMemberId,
          }}
        />
      </Box>
    </Box>
  );
};

export default Sales;